import { Link } from 'react-router-dom'
import { Users } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { useTeams } from '@/hooks/use-teams'
import { areaLabel } from '@/lib/stage'

/**
 * /team without an area: pick your team once; the choice persists (the team
 * board records it) and the sidebar deep-links straight to it afterwards.
 */
export default function TeamPicker() {
  const teams = useTeams()
  return (
    <div className="grid h-full place-items-center p-6">
      <Card className="w-full max-w-md">
        <CardContent className="flex flex-col items-center gap-4 px-8 py-8 text-center">
          <Users className="text-faint-foreground size-6" />
          <div>
            <h1 className="text-base font-semibold">Which team are you on?</h1>
            <p className="text-muted-foreground mt-1 text-xs">
              Remembered on this browser — switch any time from the team board.
            </p>
          </div>
          <div className="flex w-full flex-col gap-1.5">
            {teams.length === 0 &&
              Array.from({ length: 5 }, (_, i) => <Skeleton key={i} className="h-9 w-full" />)}
            {teams.map((area) => (
              <Link
                key={area}
                to={`/team/${area}`}
                onClick={() => {
                  try {
                    window.localStorage.setItem('n3o-work-last-area', area)
                  } catch {
                    // best-effort
                  }
                }}
                className="border-border hover:bg-hover rounded-md border px-3 py-2 text-sm font-medium"
              >
                {areaLabel(area)}
              </Link>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
